/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { MyApp } from "../../../api/apiCalls";

interface TableRowProps {
  app: MyApp;
  handleUnsubscription(app: MyApp): void;
}

const subStatus = new Map<string, string>();
subStatus.set("REGISTERED", "Registered");
subStatus.set("REG_PENDING", "Registration Pending");
subStatus.set("TEMP_BLOCKED", "Temporarily Blocked");

function TableRow({ app, handleUnsubscription }: TableRowProps) {
  const {
    name,
    lastRegisteredDate,
    rating,
    chargingAmount,
    frequency,
    appId,
    currentStatus,
  } = app;
  return (
    <tr>
      <td>
        <span className="responsive-mobile-heading">Application Name</span>
        <Link to={"/app-details/" + appId}>{name}</Link>
      </td>
      <td className="text-lg-center">
        <span className="responsive-mobile-heading">Subscribed Date</span>
        {moment(lastRegisteredDate).format("MMM D YYYY")}
      </td>
      <td className="text-lg-center">
        <span className="responsive-mobile-heading">User Rating</span>
        {rating}
      </td>
      <td className="text-lg-center">
        <span className="responsive-mobile-heading">Subscription Cost(BDT)</span>
        {(chargingAmount && frequency) ? `${chargingAmount} ${frequency?.charAt(0).toUpperCase()+frequency?.slice(1)}` : "Free"}
      </td>
      <td className="text-lg-center">
        <span className="responsive-mobile-heading">Status</span>
        {subStatus.get(currentStatus)}
      </td>
      <td className="text-lg-center">
        <span className="responsive-mobile-heading">Actions</span>
        <button
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#confirm-modal"
          onClick={(e) => {
            e.preventDefault();
            handleUnsubscription(app);
          }}
        >
          <i className="fas fa-rss"></i> Unsubscribe
        </button>
      </td>
    </tr>
  );
}

export default TableRow;
